import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'next-themes';
import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { EsqueciMinhaSenhaPage } from './modulos/autenticacao/EsqueciMinhaSenhaPage';
import { LoginPage } from './modulos/autenticacao/LoginPage';
import { RedefinirSenhaPage } from './modulos/autenticacao/RedefinirSenhaPage';
import { PrimeiroAcessoPage } from './modulos/autenticacao/PrimeiroAcessoPage';
import { AdminInicio } from './modulos/admin/AdminInicio';
import { ModeracaoOcrPage } from './modulos/admin/documentos/moderacaoOcr/ModeracaoOcrPage';
import { ConectorGovBrPage } from './modulos/admin/integracoes/ConectorGovBrPage';
import { TELAS_DE_ANALISES } from './modulos/operacao/analises/telas';
import { TELAS_DE_PARAMETRIZACAO } from './modulos/admin/parametrizacao/telas';
import { TELAS_DE_CONFIGURACAO } from './modulos/admin/parametros/telas';
import { ConvidarUsuarioPage } from './modulos/admin/usuarios/ConvidarUsuarioPage';
import { UsuarioDetalhePage } from './modulos/admin/usuarios/UsuarioDetalhePage';
import { UsuarioEditarPage } from './modulos/admin/usuarios/UsuarioEditarPage';
import { UsuariosListaPage } from './modulos/admin/usuarios/UsuariosListaPage';
import { PortalPublicacoes } from './modulos/portal/PortalPublicacoes';
import { ConsultaPublicaPage } from './modulos/portal/ConsultaPublicaPage';
import { AcompanharProtocoloPage } from './modulos/portal/AcompanharProtocoloPage';
import {
  CondutoresCredenciadoPage,
  MonitoresCredenciadoPage,
  VeiculosCredenciadoPage,
} from './modulos/portal/RecursosCredenciadoPage';
import {
  ResponsavelVinculosPage,
  TitularVinculoRecursoPage,
} from './modulos/portal/VinculosRecursosPage';
import { AptidaoRecursosPage } from './modulos/admin/AptidaoRecursosPage';
import { DecidirManutencaoRecursosPage } from './modulos/admin/DecidirManutencaoRecursosPage';
import { ManutencaoRecursosPage } from './modulos/portal/ManutencaoRecursosPage';
import { SelecionarRecortePage } from './modulos/admin/relatorios/SelecionarRecortePage';
import { MontarRastreabilidadePage } from './modulos/admin/relatorios/MontarRastreabilidadePage';
import { ExportarDocumentoPage } from './modulos/admin/relatorios/ExportarDocumentoPage';
import { VerificarDocumentoPage } from './modulos/portal/VerificarDocumentoPage';
// Portal público do transportador — autocadastro, acompanhamento e consulta.
import { AutoCadastroPage } from './modulos/portal/credenciamento/AutoCadastroPage';
import { EntrarPage } from './modulos/portal/credenciamento/identidade/EntrarPage';
import { RecuperarInscricaoPage } from './modulos/portal/credenciamento/identidade/RecuperarInscricaoPage';
import { InscricaoEnviadaPage } from './modulos/portal/credenciamento/InscricaoEnviadaPage';
import { AcompanhamentoPage } from './modulos/portal/credenciamento/AcompanhamentoPage';
import { AcompanhamentoDetalhePage } from './modulos/portal/credenciamento/AcompanhamentoDetalhePage';
import { AcessoPreCredenciadoPage } from './modulos/portal/pre-credenciamento/AcessoPreCredenciadoPage';
import { ConsultaCredenciadosPage } from './modulos/portal/consulta-credenciados/ConsultaCredenciadosPage';
import { SorteioPublicoPage } from './modulos/portal/sorteios/SorteioPublicoPage';
import { SorteiosPublicosPage } from './modulos/portal/sorteios/SorteiosPublicosPage';
import { InventariarFontesPage } from './modulos/admin/migracao-legado/InventariarFontesPage';
import { MapearTransformarPage } from './modulos/admin/migracao-legado/MapearTransformarPage';
import { ReajusteAnualPage } from './modulos/admin/parametros/reajusteAnual/ReajusteAnualPage';
import { SlaAprovacaoSmePage } from './modulos/admin/parametros/slaAprovacaoSme/SlaAprovacaoSmePage';
import { ModuloEmConstrucao } from './modulos/comum/ModuloEmConstrucao';
import {
  PaginaNaoEncontrada,
  PaginaNaoEncontradaNaArea,
} from './modulos/comum/PaginaNaoEncontrada';
import { PerfilPage } from './modulos/comum/perfil/PerfilPage';
import { CalendarioOperacional } from './modulos/operacao/calendario/CalendarioOperacional';
import { CondutoresPage as CondutoresCadastroPage } from './modulos/operacao/condutores/CondutoresPage';
import { CredenciadoDetail } from './modulos/operacao/credenciados/CredenciadoDetail';
import { CredenciadoEditarPage } from './modulos/operacao/credenciados/CredenciadoEditarPage';
import { CredenciadosPage } from './modulos/operacao/credenciados/CredenciadosPage';
import { MonitoresPage as MonitoresCadastroPage } from './modulos/operacao/monitores/MonitoresPage';
import { OperacaoInicio } from './modulos/operacao/OperacaoInicio';
import { TitularesPage } from './modulos/operacao/titulares/TitularesPage';
import { VeiculosPage as VeiculosCadastroPage } from './modulos/operacao/veiculos/VeiculosPage';
import { CadastroDetalhePage } from './modulos/operacao/cadastros/CadastroDetalhePage';
import { CadastroEdicaoPage } from './modulos/operacao/cadastros/CadastroEdicaoPage';
import { ApuracaoGridPage } from './modulos/financeiro/ApuracaoGridPage';
import { ApuracaoMensalPage } from './modulos/financeiro/ApuracaoMensalPage';
import { LancamentoOsPage } from './modulos/financeiro/apuracao/LancamentoOsPage';
import { AprovacaoSmePage } from './modulos/financeiro/AprovacaoSmePage';
import { CicloFinanceiroPage } from './modulos/financeiro/CicloFinanceiroPage';
import { DemonstrativosPage } from './modulos/financeiro/DemonstrativosPage';
import { FechamentoMensalV2ListPage } from './modulos/financeiro/fechamento-v2/FechamentoMensalV2ListPage';
import { FechamentoMensalV2DetailPage } from './modulos/financeiro/fechamento-v2/FechamentoMensalV2DetailPage';
import { FinanceiroInicio } from './modulos/financeiro/FinanceiroInicio';
import { MedicaoDetalhePage } from './modulos/financeiro/medicao-detalhe/MedicaoDetalhePage';
import { MedicoesListPage } from './modulos/financeiro/medicoes/MedicoesListPage';
import { DemonstrativosSmePage } from './modulos/financeiro/ciclo-mensal-sme/DemonstrativosSmePage';
import { MedicoesSmePage } from './modulos/financeiro/ciclo-mensal-sme/MedicoesSmePage';
import { ApontamentosPage } from './modulos/financeiro/ApontamentosPage';
import { SofPage } from './modulos/financeiro/SofPage';
import { SofConciliacaoPage } from './modulos/financeiro/sof/SofConciliacaoPage';
import { SofHistoricoPage } from './modulos/financeiro/sof/SofHistoricoPage';
import { RevisoesSmeListPage } from './modulos/financeiro/revisoes-sme/RevisoesSmeListPage';
import { SofRelatoriosPage } from './modulos/financeiro/sof/SofRelatoriosPage';
import { SofReservasPage } from './modulos/financeiro/sof/SofReservasPage';
import { SofStatusPage } from './modulos/financeiro/sof/SofStatusPage';
import { SolicitacaoSmeDetalhePage } from './modulos/financeiro/solicitacoes-sme/SolicitacaoSmeDetalhePage';
import { SolicitacoesSmeListPage } from './modulos/financeiro/solicitacoes-sme/SolicitacoesSmeListPage';
import { TratativasSmeDrePage } from './modulos/financeiro/tratativas/TratativasSmeDrePage';
import { AtesteDeMedicaoPage } from './modulos/operacao/financeiro/ateste-medicao/AtesteDeMedicaoPage';
import { AuditoriaFinanceiraPage } from './modulos/operacao/financeiro/auditoria/AuditoriaFinanceiraPage';
import { CoberturaPorDrePage } from './modulos/sme/cobertura/CoberturaPorDrePage';
import { CobrancaDetalhePage } from './modulos/operacao/financeiro/cobrancas/CobrancaDetalhePage';
import { CobrancasDamspPage } from './modulos/operacao/financeiro/cobrancas/CobrancasDamspPage';
import { IndicadoresMensaisPage } from './modulos/operacao/financeiro/indicadores-mensais/IndicadoresMensaisPage';
import { PainelExecutivoPage } from './modulos/operacao/financeiro/painel-executivo/PainelExecutivoPage';
import { ResumoAprovacaoSmePage } from './modulos/operacao/financeiro/resumo-aprovacao-sme/ResumoAprovacaoSmePage';
import { RelatoriosSmePage } from './modulos/operacao/financeiro/relatorios-sme/RelatoriosSmePage';
import { TabelaDePrecosPage } from './modulos/operacao/financeiro/tabela-precos/TabelaDePrecosPage';
import { PainelSmePage } from './modulos/sme/painel/PainelSmePage';
import { MensagensSmePage } from './modulos/sme/mensagens/MensagensSmePage';
import { NotificacoesSmePage } from './modulos/sme/notificacoes/NotificacoesSmePage';
import { ValidarDisponibilidadeOsPage } from './modulos/operacao/ValidarDisponibilidadeOsPage';
import { AtivarComunicacaoOsPage } from './modulos/operacao/AtivarComunicacaoOsPage';
import {
  DecidirMudancaOsPage,
  SolicitarMudancaOsPage,
} from './modulos/operacao/MudancaOrdemServicoPage';
import { ConsultarEntregaDtpPage } from './modulos/operacao/AprovarEntregarDtpPage';
import { CalcularComposicaoPage } from './modulos/operacao/CalcularComposicaoPage';
import { AtestarDuplaAlcadaPage } from './modulos/operacao/AtestarDuplaAlcadaPage';
import { ConciliarReferenciaPage } from './modulos/operacao/ConciliarReferenciaPage';
import { ConsolidarMedicaoPage } from './modulos/operacao/ConsolidarMedicaoPage';
import { EmpenharLiquidarPage } from './modulos/operacao/EmpenharLiquidarPage';
import { ExportarEfetivarPagamentoPage } from './modulos/operacao/ExportarEfetivarPagamentoPage';
import { ConciliarPublicarPagamentoPage } from './modulos/operacao/ConciliarPublicarPagamentoPage';
import { RegistrarOcorrenciaPage } from './modulos/operacao/RegistrarOcorrenciaPage';
import { EnquadrarNotificarPage } from './modulos/operacao/EnquadrarNotificarPage';
import { InstruirDefesaPage } from './modulos/operacao/InstruirDefesaPage';
import { DecidirDefesaPage } from './modulos/operacao/DecidirDefesaPage';
import { CobrarBaixarPage } from './modulos/operacao/CobrarBaixarPage';
import { AplicarPenalidadePage } from './modulos/operacao/AplicarPenalidadePage';
import { AuditarTrilhaPage } from './modulos/operacao/AuditarTrilhaPage';
import { TiposSolicitacaoPage } from './modulos/admin/TiposSolicitacaoPage';
import { EmailsPage } from './modulos/admin/comunicacao/EmailsPage';
import { EmailTemplateEditorPage } from './modulos/admin/comunicacao/EmailTemplateEditorPage';
import { NotificacoesTemplatesPage } from './modulos/admin/comunicacao/NotificacoesTemplatesPage';
import { ConfiguracoesHub } from './modulos/admin/parametros/configuracoes/ConfiguracoesHub';
import { PerfilUsuariosPage } from './modulos/admin/perfis/PerfilUsuariosPage';
import { ProtocolarSolicitacaoPage } from './modulos/portal/ProtocolarSolicitacaoPage';
import { ComplementarSolicitacaoPage } from './modulos/portal/ComplementarSolicitacaoPage';
import { TriarSolicitacaoPage } from './modulos/operacao/TriarSolicitacaoPage';
import { DecidirAplicarSolicitacaoPage } from './modulos/operacao/DecidirAplicarSolicitacaoPage';
import { EncerrarSolicitacaoPage } from './modulos/operacao/EncerrarSolicitacaoPage';
import { AcompanharSolicitacaoPage } from './modulos/portal/AcompanharSolicitacaoPage';
import { DemonstrativosPagamentoPage } from './modulos/portal/DemonstrativosPagamentoPage';
import { ApresentarDefesaPage } from './modulos/portal/ApresentarDefesaPage';
import { ConsultarCobrancaPage } from './modulos/portal/ConsultarCobrancaPage';
import { CobrancasPage } from './modulos/portal-credenciado/cobrancas/CobrancasPage';
import { CondutorDetailPage } from './modulos/portal-credenciado/condutores/CondutorDetailPage';
import { CondutoresPage } from './modulos/portal-credenciado/condutores/CondutoresPage';
import { ContratoDetailPage } from './modulos/portal-credenciado/contratos/ContratoDetailPage';
import { ContratosPage } from './modulos/portal-credenciado/contratos/ContratosPage';
import { CooperadosPage } from './modulos/portal-credenciado/cooperados/CooperadosPage';
import { InscreverTerceiroPage } from './modulos/portal-credenciado/cooperativa/InscreverTerceiroPage';
import { DocumentosPage } from './modulos/portal-credenciado/documentos/DocumentosPage';
import { EquipePage } from './modulos/portal-credenciado/equipe/EquipePage';
import { ExtratoConsolidadoPage } from './modulos/portal-credenciado/extrato/ExtratoConsolidadoPage';
import { FinanceiroPage } from './modulos/portal-credenciado/financeiro/FinanceiroPage';
import { MedicaoDetailPage } from './modulos/portal-credenciado/financeiro/MedicaoDetailPage';
import { FrotaEquipePage } from './modulos/portal-credenciado/frota-equipe/FrotaEquipePage';
import { PortalCredenciadoInicio } from './modulos/portal-credenciado/inicio/PortalCredenciadoInicio';
import { MinhaInscricaoPage } from './modulos/portal-credenciado/inscricao/MinhaInscricaoPage';
import { MonitorDetailPage } from './modulos/portal-credenciado/monitores/MonitorDetailPage';
import { MonitoresPage } from './modulos/portal-credenciado/monitores/MonitoresPage';
import { NotificacoesPage } from './modulos/portal-credenciado/notificacoes/NotificacoesPage';
import { PreferenciasNotificacaoPage } from './modulos/portal-credenciado/notificacoes/PreferenciasNotificacaoPage';
import { OrdemServicoDetailPage } from './modulos/portal-credenciado/ordens-servico/OrdemServicoDetailPage';
import { RecursosPage } from './modulos/portal-credenciado/recursos/RecursosPage';
import { NovaSolicitacaoPage } from './modulos/portal-credenciado/solicitacoes/NovaSolicitacaoPage';
import { SolicitacaoDetailPage } from './modulos/portal-credenciado/solicitacoes/SolicitacaoDetailPage';
import { SolicitacoesPage } from './modulos/portal-credenciado/solicitacoes/SolicitacoesPage';
import { VeiculoDetailPage } from './modulos/portal-credenciado/veiculos/VeiculoDetailPage';
import { VeiculosPage } from './modulos/portal-credenciado/veiculos/VeiculosPage';
import { AvisoDePrivacidade } from './modulos/portal/AvisoDePrivacidade';
import { CascaDoPortal } from './modulos/portal/CascaDoPortal';
import { DeclaracaoDeAcessibilidade } from './modulos/portal/DeclaracaoDeAcessibilidade';
import { PortalInicio } from './modulos/portal/PortalInicio';
import { PaginaDoPortal } from './modulos/portal/PaginaDoPortal';
import { ProvedorAuth } from './nucleo/auth/ProvedorAuth';
import { Toaster } from './ui/base/sonner';
import { RotaProtegida } from './nucleo/auth/RotaProtegida';
import { clienteConsultas } from './nucleo/cliente-consultas';
import {
  AREA_ADMIN,
  AREA_CREDENCIADO,
  AREA_OPERACAO,
  AREA_SME,
  itensDaArea,
  papeisDaRota,
  type AreaDeNavegacao,
} from './nucleo/navegacao/mapa';
import { CascaDeArea } from './nucleo/navegacao/CascaDeArea';
import { ErrorBoundary } from './ui/ErrorBoundary';
import GovernancaInstitucionalPage from './modulos/admin/governanca/governanca-Institucional/GovernancaInstitucionalPage';
import PoliticaPrevalenciaSGTPPage from './modulos/admin/governanca/politica-sgtp/PoliticaPrevalenciaSGTPPage';
import PerfisList from './modulos/admin/controle-de-acesso/perfis-de-acesso/PerfisList';
import PerfilForm from './modulos/admin/controle-de-acesso/perfis-de-acesso/novo/PerfilForm';
import { type Papel } from './nucleo/auth/papeis';
import PortalPaginasList from './modulos/admin/portal-publico/paginas/PortalPaginasList';
import PortalPaginaEditor from './modulos/admin/portal-publico/paginas/PortalPaginaEditor';
import PortalNavegacaoPage from './modulos/admin/portal-publico/navegação/PortalNavegacaoPage';
import PortalConfigPage from './modulos/admin/portal-publico/configuracao-do-portal/PortalConfigPage';
import ComunicadosList from './modulos/admin/comunicados/ComunicadosList';
import AdminDocs from './modulos/admin/documentacao/docs/AdminDocs';
import AdminDesignSystem from './modulos/admin/documentacao/design-system/AdminDesignSystem';

const PAPEIS_ADMINISTRACAO: readonly Papel[] = ['ADMIN', 'GESTOR_ADMIN'];

/**
 * As 9 telas do grupo "Operacional" (docs/ALVOS.md), carregadas sob demanda.
 *
 * Import direto (como o resto do arquivo) inflava o pacote principal de
 * ~630 kB pra ~1.074 kB — medido, não suposto: build da base sem este módulo
 * contra build com ele, mesmo commit fora isso. `lazy()` vale aqui só pras
 * telas que pesam de verdade.
 */
const AprovacoesArea = lazy(() => import('./modulos/operacional/aprovacoes/AprovacoesArea'));
const ConsultasArea = lazy(() => import('./modulos/operacional/consultas/ConsultasArea'));
const ConvocacoesArea = lazy(() => import('./modulos/operacional/convocacoes/ConvocacoesArea'));
const DescredenciamentoArea = lazy(
  () => import('./modulos/operacional/descredenciamento/DescredenciamentoArea'),
);
const FiscalizacaoHub = lazy(() => import('./modulos/operacional/fiscalizacao/FiscalizacaoHub'));
const ImportacaoEolArea = lazy(
  () => import('./modulos/operacional/importacao-eol/ImportacaoEolArea'),
);
const InscricoesArea = lazy(() => import('./modulos/operacional/inscricoes/InscricoesArea'));
const InscricoesFunilPage = lazy(
  () => import('./modulos/operacional/inscricoes/InscricoesFunilPage'),
);
const InscricoesMetricasPage = lazy(
  () => import('./modulos/operacional/inscricoes/InscricoesMetricasPage'),
);
const SorteiosArea = lazy(() => import('./modulos/operacional/sorteios/SorteiosArea'));
const PreCredenciamentoDtpArea = lazy(
  () => import('./modulos/operacional/pre-credenciamento/PreCredenciamentoDtpArea'),
);
const PreCredenciamentoPortalArea = lazy(
  () => import('./modulos/portal-credenciado/pre-credenciamento/PreCredenciamentoPortalArea'),
);
const OrdensServicoArea = lazy(
  () => import('./modulos/operacional/ordens-servico/OrdensServicoArea'),
);
const TermosArea = lazy(() => import('./modulos/operacional/termos/TermosArea'));
const TermosVencimentos = lazy(() => import('./modulos/operacional/termos/TermosVencimentos'));

/** Embrulha uma tela sob demanda, sem esqueleto de espera (mesma escolha do design system). */
function preguicosa(conteudo: React.ReactNode) {
  return <Suspense fallback={null}>{conteudo}</Suspense>;
}

/** Telas que existem hoje, por caminho. O resto do mapa vira módulo em construção. */
const TELAS_PRONTAS: Record<string, React.ReactNode> = {
  [AREA_OPERACAO.raiz]: <OperacaoInicio />,
  [AREA_ADMIN.raiz]: <AdminInicio />,
  [AREA_SME.raiz]: <PainelSmePage />,
  // O caminho é o do item que já existe no mapa de navegação
  // (nucleo/navegacao/mapa.ts). Aqui não se declara rota: só se diz qual tela a
  // rota gerada serve, no lugar do módulo em construção.
  '/admin/portal/paginas': <PortalPaginasList />,
  '/admin/portal/navegacao': <PortalNavegacaoPage />,
  '/admin/portal/configuracoes': <PortalConfigPage />,
  '/admin/perfis': <PerfisList />,
  '/admin/perfis/novo': <PerfilForm />,
  '/admin/politica-sgtp': <PoliticaPrevalenciaSGTPPage />,
  '/admin/integracoes': <ConectorGovBrPage />,
  '/admin/parametros/financeiro/reajuste-anual': <ReajusteAnualPage />,
  '/admin/parametros/sla-aprovacao-sme': <SlaAprovacaoSmePage />,
  '/admin/moderacao-ocr': <ModeracaoOcrPage />,
  '/admin/governanca-institucional': <GovernancaInstitucionalPage />,
  '/admin/comunicados': <ComunicadosList />,
  '/admin/docs': <AdminDocs />,
  '/admin/design-system': <AdminDesignSystem />,
  [AREA_CREDENCIADO.raiz]: <PortalCredenciadoInicio />,
  '/credenciado/inscricao': <MinhaInscricaoPage />,
  // Documentação do pré-credenciamento (F10): lista e, como sub-rota, o
  // dossiê `/credenciado/pre-credenciamento/:id`.
  '/credenciado/pre-credenciamento': preguicosa(<PreCredenciamentoPortalArea />),
  '/credenciado/documentos': <DocumentosPage />,
  '/credenciado/equipe': <EquipePage />,
  '/credenciado/frota-equipe': <FrotaEquipePage />,
  '/credenciado/veiculos': <VeiculosPage />,
  '/credenciado/monitores': <MonitoresPage />,
  '/credenciado/condutores': <CondutoresPage />,
  '/credenciado/cooperados': <CooperadosPage />,
  '/credenciado/cooperativa/inscrever-terceiro': <InscreverTerceiroPage />,
  '/credenciado/contratos': <ContratosPage />,
  '/credenciado/financeiro': <FinanceiroPage />,
  '/credenciado/extrato': <ExtratoConsolidadoPage />,
  '/credenciado/cobrancas': <CobrancasPage />,
  '/credenciado/recursos': <RecursosPage />,
  '/credenciado/solicitacoes': <SolicitacoesPage />,
  '/credenciado/notificacoes': <NotificacoesPage />,
  '/operacao/credenciados': <CredenciadosPage />,
  '/operacao/condutores': <CondutoresCadastroPage />,
  '/operacao/monitores': <MonitoresCadastroPage />,
  '/operacao/titulares': <TitularesPage />,
  '/operacao/veiculos': <VeiculosCadastroPage />,
  '/operacao/calendario': <CalendarioOperacional />,
  '/operacao/financeiro/fechamento-mensal': <FechamentoMensalV2ListPage />,
  '/operacao/financeiro/ciclo-financeiro': <CicloFinanceiroPage />,
  '/operacao/financeiro/sof': <SofPage />,
  '/operacao/financeiro/apuracao-mensal': <ApuracaoMensalPage />,
  '/operacao/financeiro/cobrancas': <CobrancasDamspPage />,
  '/operacao/financeiro/tabela-precos': <TabelaDePrecosPage />,
  '/operacao/financeiro/painel-executivo': <PainelExecutivoPage />,
  '/operacao/financeiro/indicadores-mensais': <IndicadoresMensaisPage />,
  '/operacao/financeiro/resumo-aprovacao-sme': <ResumoAprovacaoSmePage />,
  '/operacao/financeiro/auditoria': <AuditoriaFinanceiraPage />,
  '/operacao/financeiro/ateste-medicao': <AtesteDeMedicaoPage />,
  '/operacao/financeiro/medicoes': <MedicoesListPage />,
  '/operacao/financeiro/demonstrativos': <DemonstrativosPage />,
  '/operacao/financeiro/solicitacoes-sme': <SolicitacoesSmeListPage origem="DTP" />,
  '/operacao/financeiro/aprovacao-sme': <AprovacaoSmePage />,
  '/operacao/financeiro/apontamentos': <ApontamentosPage />,
  '/operacao/financeiro/sof/reservas': <SofReservasPage />,
  '/operacao/financeiro/sof/status': <SofStatusPage />,
  '/operacao/financeiro/sof/conciliacao': <SofConciliacaoPage />,
  '/operacao/financeiro/sof/relatorios': <SofRelatoriosPage />,
  '/operacao/financeiro/sof/historico': <SofHistoricoPage />,
  // Endereços que o protótipo também não serve como tela: lá cada um é um
  // redirecionamento para a tela que já tem o conteúdo, e aqui repete-se o
  // mesmo destino. Sem isso, caíam no hub genérico do financeiro.
  '/operacao/financeiro/apontamento-grid': (
    <Navigate to="/operacao/financeiro/apontamentos" replace />
  ),
  '/operacao/financeiro/acompanhamento-mensal': (
    <Navigate to="/operacao/financeiro/apuracao-mensal?aba=acompanhamento" replace />
  ),
  '/operacao/financeiro/calendario-prazos': (
    <Navigate to="/operacao/financeiro/fechamento-mensal" replace />
  ),
  // "Lotes SOF" é a aba de abertura do hub SOF, não tela à parte.
  '/operacao/financeiro/sof/lotes': <Navigate to="/operacao/financeiro/sof" replace />,
  // Mesmos componentes acima, registrados também sob /sme/*: o protótipo
  // duplica estas rotas, uma dentro do casco de Operação/DTP, outra dentro
  // do casco de SME (AppPageWrapper vs SmePageWrapper) — sem isso, o menu de
  // SME levava pra fora do casco de SME ao navegar (mapa.ts, AREA_SME).
  '/sme/apontamentos': <AprovacaoSmePage />,
  '/sme/resumo-aprovacao': <ResumoAprovacaoSmePage />,
  '/sme/tratativas': <TratativasSmeDrePage />,
  '/sme/demandas': <SolicitacoesSmeListPage />,
  '/sme/fechamento-mensal': <FechamentoMensalV2ListPage />,
  // Tela própria de SME, sem par em Operação/DTP: o protótipo só a registra
  // dentro do casco de SME (`SmeRevisoes.tsx`).
  '/sme/revisoes': <RevisoesSmeListPage />,
  '/sme/auditoria': <AuditoriaFinanceiraPage />,
  // Relatorios SME so existe no casco de SME: o prototipo registra esta tela
  // uma vez so, em /sme/relatorios (nao ha copia no menu do DTP).
  '/sme/relatorios': <RelatoriosSmePage />,
  // Tela própria de SME, sem par em Operação (dado simulado, exceção de
  // 2026-08-22 do CLAUDE.md — ver modulos/sme/cobertura/dados.ts).
  '/sme/cobertura': <CoberturaPorDrePage />,
  // Mensagens com credenciados, por medicao. Leitura mockada (excecao de
  // 2026-08-22 do CLAUDE.md — ver modulos/sme/mensagens/dados.ts).
  '/sme/mensagens': <MensagensSmePage />,
  // Mesma tela de /operacao/notificacoes: o protótipo monta a mesma lista nas
  // duas cascas (`SmeNotificacoesWrapper.tsx`). Ver modulos/sme/notificacoes.
  '/sme/notificacoes': <NotificacoesSmePage />,

  // Grupo "Operacional" (docs/ALVOS.md, alvo "Operacional — telas de
  // backoffice"). Fiscalização é item único no menu, igual ao protótipo — o
  // hub decide a aba (e o detalhe de Ocorrência) por sub-rota própria,
  // relativa a este caminho (ver <Routes> interno em FiscalizacaoHub.tsx).
  '/operacao/fiscalizacao': preguicosa(<FiscalizacaoHub />),
  // 'Vencimentos do mês' tem caminho PRÓPRIO no mapa de navegação (submenu
  // de Termos, nucleo/navegacao/mapa.ts) — gera sua própria <Route>, mais
  // específica que o /operacao/termos/* de baixo. Sem entrada própria aqui,
  // ela caía no módulo em construção mesmo com TermosArea sabendo resolvê-la
  // por dentro (mesmo achado de /operacao/inscricoes/funil e /metricas).
  '/operacao/termos/vencimentos': preguicosa(<TermosVencimentos />),
  '/operacao/termos': preguicosa(<TermosArea />),
  // Supera a MontarOrdemServicoPage do lote de jornadas (eb79ce9/dd69d95):
  // aquela era um rascunho direto contra o BFF, sem design system; esta é a
  // tela real (lista/assistente/detalhe) do alvo "Operacional".
  '/operacao/ordens-de-servico': preguicosa(<OrdensServicoArea />),
  // 'Funil' e 'Métricas' têm caminho PRÓPRIO no mapa de navegação (submenu
  // "Credenciamento", nucleo/navegacao/mapa.ts) — cada um gera sua própria
  // <Route> aqui, mais específica que o /operacao/inscricoes/* de baixo, e
  // React Router escolhe a mais específica quando as duas casam a mesma URL.
  // Sem entrada própria, essas duas caem no módulo em construção mesmo com
  // InscricoesArea sabendo resolvê-las por dentro — a rota de cima nunca é
  // alcançada (achado real, pego só ao navegar de verdade no navegador).
  '/operacao/inscricoes/funil': preguicosa(<InscricoesFunilPage />),
  '/operacao/inscricoes/metricas': preguicosa(<InscricoesMetricasPage />),
  '/operacao/inscricoes': preguicosa(<InscricoesArea />),
  // Sorteio do credenciamento (F08): lista de ciclos e, como sub-rota da
  // própria tela, o painel `/operacao/sorteios/:cicloId` (SorteiosArea.tsx).
  '/operacao/sorteios': preguicosa(<SorteiosArea />),
  // Documentação do pré-credenciado (F10): fila e, como sub-rota da própria
  // tela, o dossiê `/operacao/pre-credenciamento/:id`.
  '/operacao/pre-credenciamento': preguicosa(<PreCredenciamentoDtpArea />),
  '/operacao/aprovacoes': preguicosa(<AprovacoesArea />),
  '/operacao/consultas': preguicosa(<ConsultasArea />),
  '/operacao/importacao-eol': preguicosa(<ImportacaoEolArea />),
  '/operacao/convocacoes': preguicosa(<ConvocacoesArea />),
  '/operacao/descredenciamento': preguicosa(<DescredenciamentoArea />),
  // As telas de /admin/parametros vivem num catálogo próprio: são mais de vinte,
  // e o roteador não deve virar lista de telas.
  ...TELAS_DE_PARAMETRIZACAO,
  // Mesmo motivo para as telas de configuracao e parametrizacao de negocio
  // (ONDA-T1 e ONDA-T3): treze telas num catalogo proprio.
  ...TELAS_DE_CONFIGURACAO,
  // Mesmo motivo para /operacao/analises (task #2981279, ONDA-CL1 a CL4).
  ...TELAS_DE_ANALISES,
  '/admin/usuarios': <UsuariosListaPage />,
  '/admin/relatorios': <SelecionarRecortePage />,
  '/admin/relatorios/rastreabilidade': <MontarRastreabilidadePage />,
  '/admin/relatorios/exportar': <ExportarDocumentoPage />,
  '/admin/auditoria': <AuditarTrilhaPage />,
  '/admin/migracao/fontes': <InventariarFontesPage />,
  '/admin/migracao/mapeamento': <MapearTransformarPage />,
  '/operacao/aptidao-recursos': <AptidaoRecursosPage />,
  '/operacao/manutencao-recursos': <DecidirManutencaoRecursosPage />,
  '/operacao/validacao-ordens-servico': <ValidarDisponibilidadeOsPage />,
  '/operacao/ativacao-ordens-servico': <AtivarComunicacaoOsPage />,
  '/operacao/manutencao-ordens-servico': <DecidirMudancaOsPage />,
  '/operacao/apontamentos-aprovados': <ConsultarEntregaDtpPage />,
  '/operacao/composicoes-competencia': <CalcularComposicaoPage />,
  '/operacao/atestes-competencia': <AtestarDuplaAlcadaPage />,
  '/operacao/conciliacao-referencia': <ConciliarReferenciaPage />,
  '/operacao/medicoes': <ConsolidarMedicaoPage />,
  '/operacao/remuneracao': <EmpenharLiquidarPage />,
  '/operacao/pagamentos': <ExportarEfetivarPagamentoPage />,
  '/operacao/conciliacao-pagamentos': <ConciliarPublicarPagamentoPage />,
  '/operacao/ocorrencias': <RegistrarOcorrenciaPage />,
  '/operacao/penalidades': <EnquadrarNotificarPage />,
  '/operacao/defesas/instrucao': <InstruirDefesaPage />,
  '/operacao/defesas/decisao': <DecidirDefesaPage />,
  '/operacao/cobrancas': <CobrarBaixarPage />,
  '/operacao/penalidades/aplicacao': <AplicarPenalidadePage />,
  '/admin/tipos-solicitacao': <TiposSolicitacaoPage />,
  '/admin/emails': <EmailsPage />,
  '/admin/notificacoes/templates': <NotificacoesTemplatesPage />,
  '/admin/configuracoes': <ConfiguracoesHub />,
  '/operacao/solicitacoes/triagem': <TriarSolicitacaoPage />,
  '/operacao/solicitacoes/decisao': <DecidirAplicarSolicitacaoPage />,
  '/operacao/solicitacoes/encerramento': <EncerrarSolicitacaoPage />,
};

/**
 * Telas de detalhe do credenciado, com parâmetro dinâmico — não são item de
 * menu (ver `ROTAS_FORA_DO_MENU` em mapa.ts), então não entram em
 * `TELAS_PRONTAS`: entram em `FORA_DO_MENU_POR_AREA['/credenciado']`.
 */
const ROTAS_DE_DETALHE_DO_CREDENCIADO = (
  <>
    <Route path="/credenciado/veiculos/:slug" element={<VeiculoDetailPage />} />
    <Route path="/credenciado/monitores/:slug" element={<MonitorDetailPage />} />
    <Route path="/credenciado/condutores/:slug" element={<CondutorDetailPage />} />
    <Route path="/credenciado/contratos/:id" element={<ContratoDetailPage />} />
    <Route path="/credenciado/ordens-de-servico/:id" element={<OrdemServicoDetailPage />} />
    <Route path="/credenciado/financeiro/:id" element={<MedicaoDetailPage />} />
    <Route path="/credenciado/solicitacoes/nova" element={<NovaSolicitacaoPage />} />
    <Route path="/credenciado/solicitacoes/:id" element={<SolicitacaoDetailPage />} />
    <Route path="/credenciado/perfil" element={<PerfilPage />} />
    <Route path="/credenciado/perfil/notificacoes" element={<PreferenciasNotificacaoPage />} />
  </>
);

/**
 * As rotas de uma área, GERADAS do mapa de navegação.
 *
 * É isto que torna impossível divergir menu e rota: os dois nascem da mesma lista
 * (nucleo/navegacao/mapa.ts), e mapa.spec.ts falha se alguém quebrar o acordo.
 * Item cuja tela ainda não existe recebe a tela de módulo em construção — nunca
 * uma rota morta (CLAUDE.md, "Proibido").
 *
 * `CascaDeArea` é rota-layout (sem `path` próprio, um único `<Outlet/>`): ela
 * monta UMA vez por área, e as telas entram e saem dentro dela. Antes, cada
 * item de menu recriava a casca inteira — a barra lateral e o cabeçalho
 * remontavam a cada troca de tela, com piscada visível e perda do scroll da
 * lateral.
 *
 * Rota de DETALHE, com parâmetro (`:slug`), entra em `FORA_DO_MENU_POR_AREA`
 * — ela não pode ser item de `mapa.ts` (viraria uma entrada literal ":slug"
 * na barra lateral). Renderizada aqui, dentro do mesmo
 * `<RotaProtegida><CascaDeArea>`, para que a tela de detalhe mantenha sidebar
 * e cabeçalho da área; o caminho-padrão de cada uma entra em
 * `ROTAS_FORA_DO_MENU` (nucleo/navegacao/mapa.ts) com o motivo escrito.
 */
/**
 * Rotas que existem de propósito FORA do menu, por área.
 *
 * Fica aqui, e não como parâmetro de `rotasDaArea`, para a chamada continuar
 * `rotasDaArea(AREA_ADMIN)` — mapa.spec.ts confere essa linha literal, e é a
 * trava que impede alguém trocar as rotas geradas por rotas escritas à mão.
 *
 * Cada caminho abaixo tem motivo escrito em ROTAS_FORA_DO_MENU
 * (nucleo/navegacao/mapa.ts), e o mesmo teste falha se um existir sem o outro.
 */
const FORA_DO_MENU_POR_AREA: Record<string, React.ReactNode> = {
  '/admin': (
    <>
      <Route
        path="/admin/parametros/referencia/escolas/nova"
        element={TELAS_DE_PARAMETRIZACAO['/admin/parametros/referencia/escolas/nova']}
      />
      <Route
        path="/admin/parametros/referencia/escolas/:slug"
        element={TELAS_DE_PARAMETRIZACAO['/admin/parametros/referencia/escolas/:slug']}
      />
      <Route
        path="/admin/parametros/referencia/escolas/:slug/editar"
        element={TELAS_DE_PARAMETRIZACAO['/admin/parametros/referencia/escolas/:slug/editar']}
      />
      <Route
        path="/admin/parametros/referencia/seguradoras/nova"
        element={TELAS_DE_PARAMETRIZACAO['/admin/parametros/referencia/seguradoras/nova']}
      />
      <Route
        path="/admin/parametros/referencia/seguradoras/:slug"
        element={TELAS_DE_PARAMETRIZACAO['/admin/parametros/referencia/seguradoras/:slug']}
      />
      <Route
        path="/admin/parametros/referencia/seguradoras/:slug/editar"
        element={TELAS_DE_PARAMETRIZACAO['/admin/parametros/referencia/seguradoras/:slug/editar']}
      />
      <Route path="/admin/emails/templates/:id" element={<EmailTemplateEditorPage />} />
      <Route path="/admin/perfis/:id/usuarios" element={<PerfilUsuariosPage />} />
      {/* Módulo de usuários: convite em tela própria, tela interna e edição. */}
      <Route path="/admin/usuarios/convidar" element={<ConvidarUsuarioPage />} />
      <Route path="/admin/usuarios/:id" element={<UsuarioDetalhePage />} />
      <Route path="/admin/usuarios/:id/editar" element={<UsuarioEditarPage />} />
      {/*
        "Meu perfil" é destino do menu da conta, não item de barra lateral —
        por isso a mesma tela aparece uma vez por área, sempre dentro da casca
        dela. Ver `modulos/comum/perfil/README.md`.
      */}
      <Route path="/admin/perfil" element={<PerfilPage />} />
      {/*
        Par de "Meu perfil" no menu da conta, mesma tela do portal — no
        protótipo a preferência é por usuário, não por credenciado, e o mesmo
        componente serve as duas áreas.
      */}
      <Route
        path="/admin/perfil/notificacoes"
        element={<PreferenciasNotificacaoPage voltarPara="/admin" />}
      />
      {/*
        Seis das sete telas de configuração operacional (ONDA-T1), alcançadas
        pelos cards do hub "Configurações" (ConfiguracoesHub.tsx), não pela
        barra lateral — ver ROTAS_FORA_DO_MENU em mapa.ts. Todas têm tela
        própria no catálogo TELAS_DE_CONFIGURACAO, e é aqui que elas ganham
        rota: o TELAS_PRONTAS só é consultado para item de menu, e nenhuma
        destas é. A sétima, /gerais, é item de menu ("Configurações Globais")
        e ganha rota pelo laço de rotasDaArea.
      */}
      <Route
        path="/admin/configuracoes/fechamento"
        element={TELAS_DE_CONFIGURACAO['/admin/configuracoes/fechamento']}
      />
      <Route
        path="/admin/configuracoes/desvio-alerta"
        element={TELAS_DE_CONFIGURACAO['/admin/configuracoes/desvio-alerta']}
      />
      <Route
        path="/admin/configuracoes/ateste"
        element={TELAS_DE_CONFIGURACAO['/admin/configuracoes/ateste']}
      />
      <Route
        path="/admin/configuracoes/slas"
        element={TELAS_DE_CONFIGURACAO['/admin/configuracoes/slas']}
      />
      <Route
        path="/admin/configuracoes/acoes-em-lote"
        element={TELAS_DE_CONFIGURACAO['/admin/configuracoes/acoes-em-lote']}
      />
      <Route
        path="/admin/configuracoes/agendamentos"
        element={TELAS_DE_CONFIGURACAO['/admin/configuracoes/agendamentos']}
      />
    </>
  ),
  '/operacao': (
    <>
      <Route path="/operacao/financeiro/cobrancas/:id" element={<CobrancaDetalhePage />} />
      <Route path="/operacao/credenciados/:slug" element={<CredenciadoDetail />} />
      <Route path="/operacao/credenciados/:slug/editar" element={<CredenciadoEditarPage />} />
      <Route
        path="/operacao/financeiro/apuracao/lancamento/:osId/:mes"
        element={<LancamentoOsPage />}
      />
      <Route path="/operacao/financeiro/medicoes/:id" element={<MedicaoDetalhePage />} />
      <Route
        path="/operacao/financeiro/fechamento-mensal/:id"
        element={<FechamentoMensalV2DetailPage />}
      />
      <Route
        path="/operacao/financeiro/solicitacoes-sme/:id"
        element={<SolicitacaoSmeDetalhePage />}
      />
      <Route
        path="/operacao/financeiro/resumo-aprovacao-sme/:competencia"
        element={<ResumoAprovacaoSmePage />}
      />
      <Route
        path="/operacao/condutores/:slug"
        element={<CadastroDetalhePage tipo="condutores" />}
      />
      <Route
        path="/operacao/condutores/:slug/editar"
        element={<CadastroEdicaoPage tipo="condutores" />}
      />
      <Route path="/operacao/monitores/:slug" element={<CadastroDetalhePage tipo="monitores" />} />
      <Route
        path="/operacao/monitores/:slug/editar"
        element={<CadastroEdicaoPage tipo="monitores" />}
      />
      <Route path="/operacao/veiculos/:slug" element={<CadastroDetalhePage tipo="veiculos" />} />
      <Route path="/veiculos/:slug/editar" element={<CadastroEdicaoPage tipo="veiculos" />} />
      <Route path="/operacao/titulares/:slug" element={<CadastroDetalhePage tipo="titulares" />} />
      {/* Mesma tela de perfil do menu da conta — ver o par em '/admin'. */}
      <Route path="/operacao/perfil" element={<PerfilPage />} />
      <Route
        path="/operacao/perfil/notificacoes"
        element={<PreferenciasNotificacaoPage voltarPara="/operacao" />}
      />
    </>
  ),
  '/sme': (
    <>
      <Route path="/sme/fechamento-mensal/:id" element={<FechamentoMensalV2DetailPage />} />
      <Route path="/sme/resumo-aprovacao/:competencia" element={<ResumoAprovacaoSmePage />} />
      {/* Abas do Ciclo mensal, sem item de menu próprio — ver ROTAS_FORA_DO_MENU. */}
      <Route path="/sme/medicoes" element={<MedicoesSmePage />} />
      <Route path="/sme/demonstrativos" element={<DemonstrativosSmePage />} />
      <Route path="/sme/demandas/:id" element={<SolicitacaoSmeDetalhePage />} />
      {/*
        Mesma tela de perfil do menu da conta — ver o par em '/admin'. As
        preferências de notificação entraram em 2026-09-24, decisão do dono:
        o protótipo não as põe no menu da SME, mas SME e DRE passam a ter o
        mesmo par da DTP/Operação.
      */}
      <Route path="/sme/perfil" element={<PerfilPage />} />
      <Route
        path="/sme/perfil/notificacoes"
        element={<PreferenciasNotificacaoPage voltarPara="/sme" />}
      />
    </>
  ),
  '/credenciado': ROTAS_DE_DETALHE_DO_CREDENCIADO,
};

function rotasDaArea(area: AreaDeNavegacao) {
  const isAdmin = [...area.papeis].sort().join(',') === [...PAPEIS_ADMINISTRACAO].sort().join(',');
  return (
    <Route
      key={area.raiz}
      element={
        <RotaProtegida papeis={area.papeis}>
          <CascaDeArea area={area} />
        </RotaProtegida>
      }
    >
      {/*
        Rotas que existem de propósito FORA do menu — detalhe e formulário de um
        cadastro, alcançados de dentro da lista. Vêm ANTES da rota-curinga de
        "não encontrada", e cada uma tem motivo escrito em ROTAS_FORA_DO_MENU
        (nucleo/navegacao/mapa.ts), que mapa.spec.ts confere.
      */}
      {FORA_DO_MENU_POR_AREA[area.raiz]}

      {/*
        `areaReal` marca item cross-área (cross-link, igual ao protótipo):
        a rota já existe de verdade na área declarada ali, então não gera
        <Route> aqui — geraria duas rotas pro mesmo caminho, uma por área,
        com guarda de papel diferente. O item continua na barra lateral
        normalmente, `<Link to={item.caminho}>` funciona sem rota própria
        aqui porque a rota da área dona já responde por esse caminho.
      */}
      {itensDaArea(area)
        .filter((item) => !item.areaReal || item.areaReal === area.raiz)
        .map((item) => (
          <Route
            key={item.caminho}
            // O sufixo /* deixa a própria tela decidir se tem sub-rota (detalhe,
            // formulário, assistente) via <Routes> interno, relativo a este
            // caminho. Sem ele, /operacao/termos/abc cairia direto no "não
            // encontrado" da área — nenhum item tinha sub-rota até este ponto,
            // por isso o gap não tinha aparecido.
            path={`${item.caminho}/*`}
            element={
              // `item.papeis` restringe a TELA, além da área. Sem esta guarda o
              // item só sumia do menu: a rota continuava respondendo a quem
              // digitasse o endereço (ex.: DRE em /sme/revisoes via URL).
              <RotaProtegida papeis={papeisDaRota(item)} voltarPara={area.raiz}>
                {TELAS_PRONTAS[item.caminho] ??
                  (item.caminho.startsWith('/operacao/financeiro') ? (
                    <FinanceiroInicio />
                  ) : (
                    <ModuloEmConstrucao caminho={item.caminho} voltarPara={area.raiz} />
                  ))}
              </RotaProtegida>
            }
          />
        ))}

      {isAdmin && (
        <>
          <Route key={'/admin/perfis/novo'} path="/admin/perfis/novo" element={<PerfilForm />} />
          <Route key={'/admin/perfis/:id'} path="/admin/perfis/:id" element={<PerfilForm />} />
          <Route
            key={'/admin/perfis/sistema/:role'}
            path="/admin/perfis/sistema/:role"
            element={<PerfilForm />}
          />
          <Route
            key={'/admin/portal/paginas/:slug'}
            path="/admin/portal/paginas/:slug"
            element={<PortalPaginaEditor />}
          />
        </>
      )}

      {/*
        Endereço dentro da área que não bate com item nenhum do mapa. Dentro do
        shell, cercado por sidebar e cabeçalho — nunca a página solta.
      */}
      <Route path={`${area.raiz}/*`} element={<PaginaNaoEncontradaNaArea />} />
    </Route>
  );
}

/**
 * Rota de detalhe com parâmetro, fora do mapa de navegação: a grade de
 * apuração de uma DRE num mês (FIN-061), alcançada por clique numa linha da
 * listagem — não por item de menu. Usa a mesma casca de `rotasDaArea`, por
 * isso não entra nela: entrar exigiria que TODA rota gerada aceitasse
 * parâmetro, quando só esta precisa (registrada com motivo em
 * `ROTAS_FORA_DO_MENU`, nucleo/navegacao/mapa.ts).
 */
function rotaApuracaoGrid() {
  return (
    <Route
      key="apuracao-grid"
      element={
        <RotaProtegida papeis={AREA_OPERACAO.papeis}>
          <CascaDeArea area={AREA_OPERACAO} />
        </RotaProtegida>
      }
    >
      <Route
        path="/operacao/financeiro/apuracao-mensal/:mes/:dreId"
        element={<ApuracaoGridPage />}
      />
    </Route>
  );
}

/** Tela pública, dentro da casca do portal. */
function comPortal(conteudo: React.ReactNode) {
  return <CascaDoPortal>{conteudo}</CascaDoPortal>;
}

/**
 * Casca da aplicacao.
 *
 * ORDEM DOS PROVEDORES IMPORTA:
 * - `ErrorBoundary` por fora das rotas, para que erro de render em qualquer tela
 *   dê a tela de erro do design system em vez de página branca — que é
 *   exatamente o que o Prompt 6 proíbe;
 * - `ProvedorAuth` dentro do `BrowserRouter`, porque ele navega ao concluir a
 *   entrada, e em volta das rotas, porque as telas dependem dele.
 *
 * O tema escuro usa attribute="class" e a chave teg-theme
 * (docs/DESIGN-SYSTEM.md, secao 3).
 */
export function App() {
  return (
    <QueryClientProvider client={clienteConsultas}>
      <ThemeProvider attribute="class" storageKey="teg-theme" defaultTheme="system" enableSystem>
        <BrowserRouter basename={import.meta.env.BASE_URL}>
          <ErrorBoundary>
            <ProvedorAuth>
              <Routes>
                <Route path="/" element={comPortal(<PortalInicio />)} />
                <Route path="/privacidade" element={comPortal(<AvisoDePrivacidade />)} />
                <Route path="/acessibilidade" element={comPortal(<DeclaracaoDeAcessibilidade />)} />
                <Route path="/publicacoes" element={comPortal(<PortalPublicacoes />)} />
                {/*
                 * Páginas do portal servidas pelo conteúdo editorial. O editor da
                 * Administração já gravava página e seções, mas não havia rota
                 * pública que as mostrasse: quem publicava não tinha onde ver.
                 * `/portal/:slug` é o endereço canônico (é o que o próprio editor
                 * exibe); os apelidos fixos abaixo são os que o protótipo usa no
                 * menu institucional.
                 */}
                <Route path="/portal/:slug" element={comPortal(<PaginaDoPortal />)} />
                <Route path="/programa" element={comPortal(<PaginaDoPortal slug="programa" />)} />
                <Route
                  path="/credenciados"
                  element={comPortal(<PaginaDoPortal slug="credenciados" />)}
                />
                <Route
                  path="/transparencia"
                  element={comPortal(<PaginaDoPortal slug="transparencia" />)}
                />
                <Route
                  path="/dados-publicos"
                  element={comPortal(<PaginaDoPortal slug="dados-publicos" />)}
                />
                <Route
                  path="/legislacao"
                  element={comPortal(<PaginaDoPortal slug="legislacao" />)}
                />
                <Route
                  path="/termos-de-uso"
                  element={comPortal(<PaginaDoPortal slug="termos-de-uso" />)}
                />
                {/*
                 * Portal público do transportador — as jornadas que o protótipo
                 * tem e este repositório não tinha: autocadastro, acompanhamento
                 * da inscrição e consulta de credenciados. Ver
                 * `modulos/portal/credenciamento/README.md`.
                 *
                 * `/credenciados/acompanhamento` e `/dados-publicos/credenciados`
                 * eram servidas por `AcompanharProtocoloPage` e
                 * `ConsultaPublicaPage`, que consultam a API de verdade. Por
                 * decisão do dono (CLAUDE.md, 2026-09-21), as telas do protótipo
                 * assumem esses dois endereços, e aquelas continuam respondendo
                 * nos apelidos de jornada logo abaixo — nada se perdeu, mudou o
                 * endereço canônico.
                 */}
                <Route
                  path="/credenciados/autocadastro"
                  element={comPortal(<AutoCadastroPage />)}
                />
                <Route path="/credenciados/entrar" element={comPortal(<EntrarPage />)} />
                <Route
                  path="/credenciados/recuperar"
                  element={comPortal(<RecuperarInscricaoPage />)}
                />
                <Route
                  path="/credenciados/enviada/:protocolo"
                  element={comPortal(<InscricaoEnviadaPage />)}
                />
                <Route
                  path="/credenciados/acompanhamento"
                  element={comPortal(<AcompanhamentoPage />)}
                />
                <Route
                  path="/credenciados/acompanhamento/:protocolo"
                  element={comPortal(<AcompanhamentoDetalhePage />)}
                />
                <Route
                  path="/credenciados/pre-credenciado/acesso"
                  element={comPortal(<AcessoPreCredenciadoPage />)}
                />
                <Route
                  path="/dados-publicos/credenciados"
                  element={comPortal(<ConsultaCredenciadosPage />)}
                />
                {/*
                 * Resultado público do sorteio do credenciamento (F08, D-07) e
                 * a verificação no navegador. Ver `modulos/portal/sorteios/`.
                 */}
                <Route
                  path="/dados-publicos/sorteios"
                  element={comPortal(<SorteiosPublicosPage />)}
                />
                <Route
                  path="/dados-publicos/sorteios/:id"
                  element={comPortal(<SorteioPublicoPage />)}
                />
                <Route
                  path="/verificar-documento"
                  element={comPortal(<VerificarDocumentoPage />)}
                />
                <Route
                  path="/jornadas/j02/s03-consultar-publico"
                  element={comPortal(<ConsultaPublicaPage />)}
                />
                {/*
                 * J-02/S04 — consulta anônima por protocolo e CPF ou CNPJ. FICA,
                 * por decisão do dono (D4, 2026-09-30): o critério de aceite da
                 * J-02 pede consulta sem conta, e o acompanhamento novo exige a
                 * sessão do inscrito. A entrada é o cartão de entrar de
                 * `/credenciados/acompanhamento` (`AcompanhamentoSessao.tsx`).
                 */}
                <Route
                  path="/jornadas/j02/s04-acompanhar-protocolo"
                  element={comPortal(<AcompanharProtocoloPage />)}
                />
                {/*
                 * TELAS DE JORNADA APOSENTADAS (D3, decisão do dono de
                 * 2026-09-30). O fluxo novo do credenciamento (#159) cumpre o
                 * mesmo critério de aceite destas, ou o dono tirou o passo do
                 * escopo, então o endereço antigo só redireciona — com
                 * `replace`, para o botão Voltar não cair de novo aqui — e link
                 * já divulgado continua levando a algum lugar. Nenhum deles
                 * levava query ou token de que o destino precise: o `?ciclo=`
                 * da S02 sai porque o autocadastro escolhe sozinho o período
                 * aberto, e o `?token=` da consentir-terceiro sai porque não há
                 * mais consentimento a colher.
                 *
                 * - S02 (identificar e manter rascunho) e S03 (revisar e
                 *   protocolar): o autocadastro — portão por CPF ou gov.br,
                 *   assistente salvo no servidor com versão otimista e envio
                 *   idempotente com protocolo por veículo;
                 * - S05 (corrigir inscrição devolvida): o acompanhamento, cujo
                 *   detalhe abre a correção só dos campos pedidos, com prazo,
                 *   versão e histórico;
                 * - S06 (cumprir convocação): o acompanhamento também — a
                 *   convocação nova é presencial, o DTP registra o desfecho e a
                 *   habilitação cria o credenciado; o candidato acompanha o
                 *   andamento dali.
                 *
                 * - S04 (consentimento de titular terceiro), nas duas pontas:
                 *   RETIRADA DO ESCOPO pelo dono em 2026-09-30 — o fluxo novo
                 *   não pede anuência de terceiro. A preparação, que o
                 *   candidato fazia no meio da inscrição, vai ao autocadastro;
                 *   o link do convite que o titular recebia por e-mail
                 *   (`consentimento-titular.service.ts`, a única origem desses
                 *   convites) vai ao início do portal, porque o titular não é
                 *   inscrito e não tem inscrição a acompanhar.
                 *
                 * BFF e módulos de API saem em alvo de backend próprio
                 * (`docs/ALVOS.md`).
                 */}
                <Route
                  path="/jornadas/j03/s02-identificar-rascunho"
                  element={<Navigate to="/credenciados/autocadastro" replace />}
                />
                <Route
                  path="/jornadas/j03/s03-protocolar-inscricao"
                  element={<Navigate to="/credenciados/autocadastro" replace />}
                />
                <Route
                  path="/jornadas/j03/s04-preparar-consentimento"
                  element={<Navigate to="/credenciados/autocadastro" replace />}
                />
                <Route
                  path="/jornadas/j03/s04-consentir-terceiro"
                  element={<Navigate to="/" replace />}
                />
                <Route
                  path="/jornadas/j03/s05-corrigir-inscricao"
                  element={<Navigate to="/credenciados/acompanhamento" replace />}
                />
                <Route
                  path="/jornadas/j03/s06-cumprir-convocacao"
                  element={<Navigate to="/credenciados/acompanhamento" replace />}
                />
                <Route
                  path="/portal/credenciado/veiculos"
                  element={
                    <RotaProtegida papeis={['CREDENCIADO']}>
                      {comPortal(<VeiculosCredenciadoPage />)}
                    </RotaProtegida>
                  }
                />
                <Route
                  path="/portal/credenciado/manutencao-recursos"
                  element={
                    <RotaProtegida papeis={['CREDENCIADO']}>
                      {comPortal(<ManutencaoRecursosPage />)}
                    </RotaProtegida>
                  }
                />
                <Route
                  path="/portal/credenciado/vinculos"
                  element={
                    <RotaProtegida papeis={['CREDENCIADO']}>
                      {comPortal(<ResponsavelVinculosPage />)}
                    </RotaProtegida>
                  }
                />
                <Route
                  path="/jornadas/j05/s02-confirmar-titular"
                  element={comPortal(<TitularVinculoRecursoPage />)}
                />
                <Route
                  path="/portal/credenciado/condutores"
                  element={
                    <RotaProtegida papeis={['CREDENCIADO']}>
                      {comPortal(<CondutoresCredenciadoPage />)}
                    </RotaProtegida>
                  }
                />
                <Route
                  path="/portal/credenciado/monitores"
                  element={
                    <RotaProtegida papeis={['CREDENCIADO']}>
                      {comPortal(<MonitoresCredenciadoPage />)}
                    </RotaProtegida>
                  }
                />
                {/* As OS do credenciado estão em Contratos e Termos, por termo
                 * (decisão do dono, 2026-10-02). Os dois endereços antigos só
                 * redirecionam: o e-mail OS_ATIVA continua apontando para
                 * ordens-ativas (CAMINHO_DO_PORTAL_DA_OS, na API). A área
                 * /credenciado guarda o destino. */}
                <Route
                  path="/portal/credenciado/ordens-ativas"
                  element={<Navigate to="/credenciado/contratos" replace />}
                />
                <Route
                  path="/portal/credenciado/ordens-em-execucao"
                  element={<Navigate to="/credenciado/contratos" replace />}
                />
                <Route
                  path="/portal/credenciado/mudancas-os"
                  element={
                    <RotaProtegida papeis={['CREDENCIADO']}>
                      {comPortal(<SolicitarMudancaOsPage />)}
                    </RotaProtegida>
                  }
                />
                <Route
                  path="/portal/credenciado/demonstrativos-pagamento"
                  element={
                    <RotaProtegida papeis={['CREDENCIADO']}>
                      {comPortal(<DemonstrativosPagamentoPage />)}
                    </RotaProtegida>
                  }
                />
                <Route
                  path="/portal/credenciado/recursos"
                  element={
                    <RotaProtegida papeis={['CREDENCIADO']}>
                      {comPortal(<ApresentarDefesaPage />)}
                    </RotaProtegida>
                  }
                />
                <Route
                  path="/portal/credenciado/cobrancas"
                  element={
                    <RotaProtegida papeis={['CREDENCIADO']}>
                      {comPortal(<ConsultarCobrancaPage />)}
                    </RotaProtegida>
                  }
                />
                <Route
                  path="/portal/solicitacoes/nova"
                  element={
                    <RotaProtegida papeis={['CREDENCIADO']}>
                      {comPortal(<ProtocolarSolicitacaoPage />)}
                    </RotaProtegida>
                  }
                />
                <Route
                  path="/portal/solicitacoes/complementar"
                  element={
                    <RotaProtegida papeis={['CREDENCIADO']}>
                      {comPortal(<ComplementarSolicitacaoPage />)}
                    </RotaProtegida>
                  }
                />
                <Route
                  path="/portal/solicitacoes/acompanhar"
                  element={
                    <RotaProtegida papeis={['CREDENCIADO']}>
                      {comPortal(<AcompanharSolicitacaoPage />)}
                    </RotaProtegida>
                  }
                />

                <Route path="/login" element={<LoginPage />} />
                <Route path="/esqueci-minha-senha" element={<EsqueciMinhaSenhaPage />} />
                <Route path="/redefinir-senha" element={<RedefinirSenhaPage />} />
                <Route path="/primeiro-acesso" element={<PrimeiroAcessoPage />} />

                {rotasDaArea(AREA_OPERACAO)}
                {rotaApuracaoGrid()}
                {rotasDaArea(AREA_ADMIN)}
                {rotasDaArea(AREA_SME)}
                {rotasDaArea(AREA_CREDENCIADO)}

                <Route path="*" element={<PaginaNaoEncontrada />} />
              </Routes>

              {/*
                O lugar onde os avisos curtos aparecem. Até aqui NENHUM
                `<Toaster />` estava montado, e todo `toast()` do sistema
                empilhava aviso num lugar que ninguém desenhava: a ação tinha
                efeito e o usuário não via nada (o alerta estava escrito em
                `ui/Notificacao.tsx`).

                Escolhido o Toaster de `ui/base/sonner.tsx`, e não o do
                `useToast` do shadcn, por três razões: ele é o que este
                projeto integrou ao design system — cor e ícone semânticos por
                token (`--success`, `--destructive`, `--warning`, `--info`),
                ícones do Lucide e `aria-live="polite"` no invólucro, enquanto
                o outro é o gerado do shadcn, monocromático e sem ícone; o
                protótipo aprovado também usa sonner; e é dele que vem o
                `toast` já usado nas telas de administração.

                Fica dentro do ProvedorAuth para o aviso sobreviver à
                navegação entre rotas, e fora do Routes porque não é rota.
              */}
              <Toaster />
            </ProvedorAuth>
          </ErrorBoundary>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
